<template>
  <div>
    <MetricFilters
      class="tw-mb-3"
      filters-state-relative-path="permitActionDatesMetricsFilters"
    />
    <div class="tw-w-full tw-h-32 tw-mb-2">
      <canvas
        ref="PermitActionDatesBarChart"
      />
    </div>
    <AdministrationTableHeader
      store-path="v2/admin/dashboard"
      filters-state-relative-path="permitActionDatesMetricsFilters"
      filters-mutation-relative-path="sortPermitActionDatesMetricsByUser"
      :columns="columns"
      :need-to-translate-column-title="false"
    />
    <div class="tw-border tw-border-gray dark:tw-border-dm-gray tw-overflow-hidden tw-rounded-3xl">
      <template
        v-for="(userMetric, index) in permitActionDatesMetricsByUser"
        :key="userMetric.actor_id"
      >
        <div
          v-if="index > 0"
          class="tw-w-full tw-h-px tw-bg-gray dark:tw-bg-dm-gray"
        />
        <div
          class="tw-flex tw-items-center tw-py-1.5 tw-px-3 tw-gap-3 hover:tw-bg-light dark:hover:tw-bg-dm-light"
        >
          <div
            class="tw-flex tw-items-center tw-leading-5 tw-tracking-normal"
            :style="`width: ${columns[0].width}`"
          >
            {{ userMetric.actor_fullname }}
          </div>
          <div :style="`width: ${columns[1].width}`">
            {{ userMetric.total ?? '-' }}
          </div>
          <div :style="`width: ${columns[2].width}`">
            {{ userMetric.filled ?? '-' }}
          </div>

          <div
            class="tw-leading-5 tw-tracking-normal"
            :style="`width: ${columns[3].width}`"
          >
            {{ userMetric.skipped ?? '-' }}
          </div>
          <div
            class="tw-leading-5 tw-tracking-normal"
            :style="`width: ${columns[4].width}`"
          >
            {{ userMetric.filled_shared ?? '-' }}
          </div>
          <div
            class="tw-leading-5 tw-tracking-normal"
            :style="`width: ${columns[5].width}`"
          >
            {{ userMetric.completion_rate ? userMetric.completion_rate + ' %' : '-' }}
          </div>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import { permitActionDatesMetricsTableColumns } from '@/views/admin/dashboard/constants';
import MetricFilters from '@/views/admin/dashboard/components/MetricFilters.vue';
import AdministrationTableHeader from '@/components/Administration/components/AdministrationTableHeader.vue';
import { shallowRef } from 'vue';
import { Chart } from 'chart.js';

export default {
  name: 'PermitActionDateMetricsTable',
  components: { AdministrationTableHeader, MetricFilters },
  data() {
    return {
      chart: null,
    };
  },
  computed: {
    ...mapState({
      permitActionDatesMetricsByUser: (state) => state.v2.admin.dashboard.permitActionDatesMetricsByUser,
      permitActionDatesTotalMetrics: (state) => state.v2.admin.dashboard.permitActionDatesTotalMetrics,
    }),
    columns() {
      return permitActionDatesMetricsTableColumns(this.$t);
    },
    chartData() {
      const metrics = this.permitActionDatesTotalMetrics;
      return {
        skipped: Number(metrics.skipped ?? 0),
        filled: Number(metrics.filled ?? 0),
        filled_shared: Number(metrics.filled_shared ?? 0),
      };
    },
  },
  watch: {
    chartData: {
      handler(newValue) {
        this.updateChart(newValue);
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    this.initChart();
    if (this.chartData.skipped && this.chartData.filled) {
      this.updateChart(this.chartData);
    }
  },
  beforeUnmount() {
    if (this.chart) {
      this.chart.destroy();
      this.chart = null;
    }
  },
  methods: {
    updateChart(data) {
      if (!this.chart) return;
      this.chart.data.datasets[0].data = [data.skipped];
      this.chart.data.datasets[1].data = [data.filled_shared];
      this.chart.data.datasets[2].data = [data.filled - data.filled_shared];
      this.chart.update();
    },
    initChart() {
      const ctx = this.$refs.PermitActionDatesBarChart;
      if (!ctx) return;

      const data = this.chartData;

      this.chart = shallowRef(new Chart(ctx, {
        type: 'bar',
        data: {
          labels: [''],
          datasets: [
            {
              label: this.$t('dashboard.permit_metrics.skipped'),
              data: [data.skipped],
              backgroundColor: '#E99C60',
              barThickness: 30,
            },
            {
              label: this.$t('dashboard.permit_action_date_metrics.filled_shared'),
              data: [data.filled_shared],
              backgroundColor: '#74BD3A',
              barThickness: 30,
            },
            {
              label: this.$t('dashboard.permit_metrics.filled'),
              data: [data.filled - data.filled_shared],
              backgroundColor: '#74BD3AAA',
              barThickness: 30,
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          indexAxis: 'y',
          plugins: {
            legend: {
              display: true,
              position: 'bottom',
            },
          },
          scales: {
            x: {
              stacked: true,
              beginAtZero: true,
            },
            y: {
              stacked: true,
            },
          },
        },
      }));
    },
  },
};
</script>
